import { computed } from 'vue';
import { concat, map, omitBy } from 'lodash-es';
import { useI18n } from 'vue-i18n';

export const useArticle = (
  props,
  getOptionParam,
  getOptionItemParam,
  configuration,
  reference,
  formattedTotalPrice,
  result,
  // eslint-disable-next-line max-params
) => {
  const { t } = useI18n();

  const article = computed(() => ({
    title: t('EngravingTool.summary.label', {
      engraving: getOptionItemParam(
        'engravings',
        configuration.value.engraving,
        'label',
        configuration.value.engraving,
      ),
      timepiece: t(`EngravingTool.reference.${reference.value}`),
    }),
    options: concat(
      [{ key: t('EngravingTool.options.reference'), value: reference.value }],
      map(
        omitBy(configuration.value.personalisation, (value) => value === null),
        (value, key) => ({
          key: getOptionParam(
            props.matchConfigurationIds[key],
            'label',
            getOptionItemParam('engravings', props.matchConfigurationIds[key], 'label', key),
          ),
          value: getOptionItemParam(props.matchConfigurationIds[key], value, 'label', value),
        }),
      ),
      map(
        omitBy(configuration.value.options, (value) => value === null),
        (value, key) => ({
          key: getOptionParam(
            props.matchConfigurationIds[key],
            'label',
            getOptionItemParam('engravings', props.matchConfigurationIds[key], 'label', key),
          ),
          value: getOptionItemParam(props.matchConfigurationIds[key], value, 'label', value),
        }),
      ),
    ),
    price: formattedTotalPrice.value,
    image: {
      image: {
        src: result.value.previewUrl,
        srcset: result.value.previewUrl,
      },
    },
  }));

  return {
    article,
  };
};
